export const APPLICATION_ROUTES = {
  BASE_URL: "simpayx",
  PICKUP: "pickup",
  SITE_URL: "https://dinein.simpexo.com/",
  CHECKOUT: "checkout",
  ORDER_STATUS: "order-status",
  PAYMENT: "payment",
  RESERVATION: "reservation",
  RESERVATION_REVIEW: "review",
  RESERVATION_COMPLETED: "complete",
  RESERVATION_CONFIRMATION: "confirm",
  VOUCHER: "voucher",
  FEEDBACK: "feedback",
  ORDER_TYPE: "order-type",
  OFFLINE_PAYMENT: "offline-payment",
  LANDING: "landing",
  MENU: "menu",
  UBRYD_URL: "https://ubryd.in"
};
